export const rank: (dataRange: number[]) => (val: number) => number = (dataRange: number[]) => {
	const dataRangeSorted = dataRange.slice().sort((a, b) => (b - a));
	return (val: number) => {
		if (val == 0) {
			return 0;
		}
		return dataRangeSorted.indexOf(val) + 1;
	};
};

export const classNameColorRank = (r: number) => {
	return {
		artifact: r === 1,
		legendary: 2 <= r && r <= 5,
		epic: 6 <= r && r <= 10,
		rare: 11 <= r && r <= 15
	};
};

export const classNameTierSetsComplete = (n: number) => {
	return {
		"no-bonus-set": n < 2,
		"bonus-set-2": 2 <= n && n < 4,
		"bonus-set-4": 4 <= n && n <= 5
	};
};


// const average = function (array: any[], elementFunction: any) {
// 	let sum = 0;
// 	let count = 0;
// 	for (const a of array) {
// 		const e = elementFunction(a);
// 		if (e) {
// 			sum += e;
// 			++count;
// 		}
// 	}
// 	return count > 0 ? sum / count : 0;
// };

// const nFormatter = function (num: number, digits: number) {
// 	const si = [
// 		// { value: 1E18, symbol: "E" },
// 		// { value: 1E15, symbol: "P" },
// 		// { value: 1E12, symbol: "T" },
// 		{ value: 1E9, symbol: "B" },
// 		{ value: 1E6, symbol: "M" },
// 		{ value: 1E3, symbol: "k" }
// 	];
// 	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
// 	for (const s of si) {
// 		if (num >= s.value) {
// 			return (num / s.value).toFixed(digits).replace(rx, "$1") + s.symbol;
// 		}
// 	}
// 	return num.toFixed(digits).replace(rx, "$1");
// };
